import { Controller } from "@hotwired/stimulus"

// Posts the document height to the embedding parent page (e.g. the iframe on
// dinck.nl) so it can resize the iframe and avoid inner scrollbars. The
// message carries only a height, so any parent origin may receive it.
export default class extends Controller {
  connect() {
    this.observer = new ResizeObserver(() => this.postHeight())
    this.observer.observe(this.element)
    this.postHeight()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  postHeight() {
    if (window.parent === window) return

    window.parent.postMessage(
      { type: "dinck:embed:height", height: document.documentElement.scrollHeight },
      "*"
    )
  }
}
